module.exports = __webpack_public_path__ + "03_short_grey.8683f1bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_short_grey.png
// module id = oCzz
// module chunks = 0